import { Flex, Image } from "antd";
import * as React from "react";
import styled from "styled-components";
import Typography from "../../components/typography/index.tsx";
import { Currency, Product } from "../../services/shopService.ts";
import { campaignPrice, discountPercent, formatPrice } from "../../services/pricing.ts";

interface ProductPreviewInterface {
  product: Product;
  /** У категорії за типом одягу чоловіча і жіноча моделі часто мають однакову
   *  назву і поруч виглядають як дубль. На сторінках /men і /women це зайве. */
  showSex?: boolean;
}

const SEX_LABEL = ["ЧОЛОВІКАМ", "ЖІНКАМ", "УНІСЕКС"];

const ProductPreviewContainer = styled.div`
  cursor: pointer;
  padding: 8px 4px;
  display: grid;
  height: fit-content;
  box-sizing: border-box;
  align-items: center;
  >div {
    align-self: self-start;
  }
`;

/**
 * Фото в каталозі різних пропорцій: студійні вертикальні, живі -- ширші.
 * Без фіксованого кадру сітка рветься і ряд з'їжджає. Кадр 3:4, картинка
 * вписується по covere -- усі картки однакової висоти.
 */
const ImageFrame = styled.div`
  width: 100%;
  aspect-ratio: 3 / 4;
  overflow: hidden;
  background: #F4F4F5;
  .ant-image {
    width: 100%;
    height: 100%;
    display: block;
  }
  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: block;
  }
`;

const ProductPreview = ({ product, showSex = false }: ProductPreviewInterface) => {
  const [productPreview, setProductPreview] = React.useState<string>();
  const [imageHovered, setImageHovered] = React.useState(false);

  React.useEffect(() => {
    const link = product.productImages.find((productImage) =>
      imageHovered ? productImage.is3dModel : productImage.isPrimary
    )?.link;
    setProductPreview(link);
  }, [imageHovered, product.productImages]);

  return (
    productPreview && (
      <ProductPreviewContainer onMouseOver={() => setImageHovered(true)} onMouseLeave={() => setImageHovered(false)}>
        <ImageFrame>
          <Image src={productPreview} alt={product.description} preview={false} />
        </ImageFrame>
        <div style={{ alignSelf: "end", flexDirection: "column", display: "flex", gap: "6px", paddingTop: "6px" }}>
          <Typography variant="h5" style={{ textTransform: 'uppercase' }}>{product.name}</Typography>
          {showSex && SEX_LABEL[product.sex] && (
            <Typography variant="h5" style={{ color: "#A2A7B8", letterSpacing: "0.04em" }}>
              {SEX_LABEL[product.sex]}
            </Typography>
          )}
          <Flex align="baseline" gap="8px" wrap="wrap">
            <Typography variant="h5" style={{ color: "#1F2333" }}>
              {Currency[product.currencyId]}{formatPrice(campaignPrice(product.price))}
            </Typography>
            <Typography
              variant="h5"
              style={{ color: "#A2A7B8", textDecoration: "line-through" }}
            >
              {Currency[product.currencyId]}{formatPrice(product.price)}
            </Typography>
            <span
              style={{
                fontSize: "11px",
                fontWeight: 700,
                color: "#A9603C",
                background: "rgba(169, 96, 60, 0.12)",
                borderRadius: "999px",
                padding: "2px 7px",
              }}
            >
              -{discountPercent(product.price)}%
            </span>
          </Flex>
        </div>
      </ProductPreviewContainer>
    )
  );
};

export default ProductPreview;
